import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import ComparisonLoanpartComponent from './ComparisonLoanpartComponent';
import ShowComponent from '../../hocs/ShowComponent';

@ShowComponent
@observer
class ComparisonLoanpartsFormComponent extends React.Component {
  render() {
    const { loanparts, firstLabelId, secondLabelId } = this.props.ComparisonFormData;

    const lastIndex = loanparts.slice().length - 1;

    let loanpartRows = loanparts.map((loanpart, index) => (
      <ComparisonLoanpartComponent
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        index={index}
        value={loanpart}
        lastIndex={lastIndex}
      />
    ));

    if (firstLabelId === 0 || secondLabelId === 0) {
      loanpartRows = null;
    }

    return (
      <div className="row columns comparison-form__loanparts">
        {loanpartRows}
      </div>
    );
  }
}

ComparisonLoanpartsFormComponent.propTypes = {
  ComparisonFormData: PropTypes.shape({
    loanparts: PropTypes.arrayOf(PropTypes.number),
    firstLabelId: PropTypes.number,
    secondLabelId: PropTypes.number,
  }),
};

ComparisonLoanpartsFormComponent.defaultProps = {
  ComparisonFormData: {
    loanparts: [],
    firstLabelId: 0,
    secondLabelId: 0,
  },
};

export default inject('ComparisonFormData')(ComparisonLoanpartsFormComponent);
